const RecreationIcon = ({className, pathClassName}) => (
<svg className={className}
     viewBox="0 0 72 70">
 <path className={pathClassName} d="m0 49.8 24.1-.2v5.2h-8.2l-.1 10 27.5.1 1.9-20.3-1.4-.2s-4.5 4.7-12 1.4a9.2 9.2 0 0 1-5.5-7.7c-1-8.2 6.4-11.3 6.2-12.5-.1-.7-3.2-3.6-2.3-7.6-.8-3.7 2.4-5.5 4.7-6.7 2.2-1.2 4.2-1 4.2-1-2-14.9 20.6-13 17 0 0 0 6.2 0 7.8 6 1.6 6-2 9.5-2 9.5s6.3 3.5 6 10.9c-.2 7.4-6 10.5-9.1 10.5-3 0-5.3-1-5.4-1L50 44.4h-1.1l1.4 20.3h21.3v5h-72v-5h9V54.7h-9l-.2-5 .6.2Z"/>
</svg>
)

export default RecreationIcon
